import Tab from "components/common/Tab/tab";
import Tabs from "components/common/Tab/tabs";
import { useParams } from "next/navigation";
import { useRouter } from "next/router";
import useIsDetailLoading from "states/detailLoading";
import { useEffect, useRef } from "react";
import { parse } from "querystring";
import { routeToStockDetailPage } from "utils/routing";
import { useTabTracking } from "lib/analytics/react/hooks";
import { useTranslation } from "next-i18next";
function DetailTab({
  isMobile,
  totalPercent,
}: {
  isMobile: boolean;
  totalPercent: number;
}) {
  const router = useRouter();
  const { t } = useTranslation("detail");
  const isDetailLoading = useIsDetailLoading();
  const { ticker } = useParams();
  const contentTopRef = useRef<number>(0);
  const tabRef = useRef<HTMLDivElement>(null);
  const tabTop = useRef<number>(0);

  const { trackClick } = useTabTracking("stock_tab_click", [
    "overview",
    "score",
    "fund",
    "feed",
  ]);
  useEffect(() => {
    if (isDetailLoading) return;
    const contents = document.querySelector(".detail-tab-content");
    if (contents) {
      contentTopRef.current = contents.getBoundingClientRect().top;
    }
    const handleRouteChangeComplete = () => {
      const tabHeight = tabRef.current?.getBoundingClientRect().height;

      if (contentTopRef.current !== undefined && tabHeight !== undefined) {
        const url = window.location.href;
        const queryString = url.split("?")[1] || "";
        const queryObj = parse(queryString);
        const tab = queryObj.tab;
        setTimeout(() => {
          if (!tab) return;
          window.scrollTo({
            top: contentTopRef.current - tabHeight - (isMobile ? 64 : 120),
            behavior: "smooth",
          });
        }, 100);
      }
    };

    router.events.on("routeChangeComplete", handleRouteChangeComplete);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChangeComplete);
    };
  }, [tabTop?.current, isDetailLoading]);
  const isNotTotalScoreProvided = !totalPercent && String(totalPercent) !== "0";
  if (isDetailLoading) return null;
  return (
    <div
      className=" global-tabs  sticky  z-10 bg-white"
      style={{
        top: isMobile ? "64px" : "120px",
      }}
      ref={tabRef}
    >
      <Tabs type={"line"} className="!border-0 px-1">
        <Tab
          dataGtmId={"sDetail-tab-overview"}
          title={t("tabOverview")}
          onClick={() => {
            trackClick("overview");
            routeToStockDetailPage(
              router,
              ticker as string,
              "push",
              {
                shallow: true,
              },
              "overview"
            );
          }}
          isActive={router.query?.tab === "overview" || !router.query?.tab}
          type="line"
          tabClassNameAdd="!px-3 !py-[14px]"
        />
        {!isNotTotalScoreProvided && (
          <Tab
            dataGtmId={"sDetail-tab-score"}
            title={t("investmentAttractiveness")}
            onClick={() => {
              trackClick("score");
              routeToStockDetailPage(
                router,
                ticker as string,
                "push",
                {
                  shallow: true,
                },
                "score"
              );
            }}
            isActive={router.query?.tab === "score"}
            type="line"
            tabClassNameAdd="!px-3 !py-[14px]"
          />
        )}
        <Tab
          dataGtmId={"sDetail-tab-info"}
          title={t("tabCompanyInfo")}
          onClick={() => {
            trackClick("fund");
            routeToStockDetailPage(
              router,
              ticker as string,
              "push",
              {
                shallow: true,
              },
              "info"
            );
          }}
          isActive={router.query?.tab === "info"}
          type="line"
          tabClassNameAdd="!px-3 !py-[14px]"
        />

        <Tab
          dataGtmId={"sDetail-tab-aireport"}
          title={t("tabFeed")}
          onClick={() => {
            trackClick("feed");
            routeToStockDetailPage(
              router,
              ticker as string,
              "push",
              {
                shallow: true,
              },
              "aireport"
            );
          }}
          isActive={router.query?.tab === "aireport"}
          type="line"
          tabClassNameAdd="!px-3 !py-[14px]"
        />
      </Tabs>
    </div>
  );
}

export default DetailTab;
